'use client'

import { useState } from 'react'
import Link from 'next/link'
import Tabs from 'src/components/design-system/Tabs'

const formatter = new Intl.NumberFormat('pl-PL')

// Top 10 w zakładkach (Artykuły / Ahead of Print / Rozdziały); dane przychodzą z serwera, zakładki przełączane po stronie klienta.
export default function StatisticsRankingTabs({ tabs, valueLabel, labels, ariaLabel }) {
  const [activeTab, setActiveTab] = useState(tabs[0]?.id)
  const current = tabs.find((tab) => tab.id === activeTab) || tabs[0]
  const items = current?.items || []

  return (
    <div>
      <Tabs
        tabs={tabs.map(({ id, label }) => ({ id, label }))}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        ariaLabel={ariaLabel}
      />
      {items.length === 0 ? (
        <p className="py-24">{labels.empty}</p>
      ) : (
        <ol className="grid gap-x-42 gap-y-24 py-24 t:grid-cols-2" style={{ listStyle: 'none', padding: 0 }}>
          {items.map((item, index) => (
            <li key={item.uuid} className="flex gap-16">
              <span aria-hidden="true">{index + 1}.</span>
              <div>
                {item.href ? (
                  <Link href={item.href}>
                    <strong>{item.title || item.uuid}</strong>
                  </Link>
                ) : (
                  <strong>{item.title || item.uuid}</strong>
                )}
                {item.authors && <div className="text-small">{item.authors}</div>}
                <div className="text-small">
                  {item.source && (
                    <span>
                      {current.kind === 'chapters' ? labels.book : labels.journal}: {item.source}
                    </span>
                  )}
                  {item.issue != null && <span>{` · ${labels.issue} ${item.issue}`}</span>}
                  {item.volume && <span>{` · ${labels.volume} ${item.volume}`}</span>}
                </div>
                <div className="text-small">
                  {formatter.format(item.value)} {valueLabel}
                </div>
              </div>
            </li>
          ))}
        </ol>
      )}
    </div>
  )
}
